import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddStaffAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        staffId: "",
        status: "",
        remarks: "",
      },
      statusError: "",
      remarksError: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        staffId: data.staffId,
        status: data.status ? data.status : "",
        remarks: data.remarks ? data.remarks : "",
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleStatus = (e) => {
    this.setState({
      data: { ...this.state.data, status: e.target.value },
    });
  };

  checkError = () => {
    let statusError = "";
    let remarksError = "";

    if (this.state.data.status === "") {
      statusError = "Please enter the attendance status";
    }

    if (this.state.data.status === "A" || this.state.data.status === "L") {
      if (this.state.data.remarks === "") {
        remarksError = "Please mention why the staff is absent or wants leave";
      }
    }

    if (statusError || remarksError) {
      this.setState({
        statusError,
        remarksError,
      });
      return true;
    } else {
      this.setState({
        statusError: "",
        remarksError: "",
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = data;
    if (!changedData.remarks) {
      delete changedData.remarks;
    }
    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let toFilterData = {
          staffId: this.props.data.staffId._id,
          status: this.state.data.status,
          remarks: this.state.data.remarks,
          date: this.props.data.date,
        };
        let data = this.filterData(toFilterData);
        const response = await Axios.put(
          `${url}/api/staff-attendance/${this.props.attendanceId}`,
          data,
          { headers: { Authorization: `Bearer ${this.props.adminToken}` } }
        );
        if (response.data.message === "Staff attendance edited successfully") {
          this.props.handleCancelEdit();
          this.props.getStaffAttendance();
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { data } = this.state;
    const { classes, handleCancelEdit } = this.props;
    return (
      <TableRow>
        <TableCell align="center" />
        <TableCell align="center">{data.staffId.fullName}</TableCell>
        <TableCell align="center">{data.staffId.department}</TableCell>
        <TableCell align="center">{data.staffId.designation}</TableCell>
        <TableCell align="center">
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="position"
              name="status"
              defaultValue="P"
              value={data.status}
              onChange={this.handleStatus}
            >
              <FormControlLabel
                value="P"
                control={<Radio style={{ color: "#008000" }} />}
                label="P"
              />
              <FormControlLabel
                value="A"
                control={<Radio style={{ color: "#ff00000" }} />}
                label="A"
              />
              <FormControlLabel
                value="L"
                control={<Radio style={{ color: "#ffa500" }} />}
                label="L"
              />
            </RadioGroup>
          </FormControl>
          {data.status === "P" && (
            <p style={{ color: "green", fontWeight: "bold" }}>Present</p>
          )}
          {data.status === "A" && (
            <p style={{ color: "red", fontWeight: "bold" }}>Absent</p>
          )}
          {data.status === "L" && (
            <p style={{ color: "orange", fontWeight: "bold" }}>Leave</p>
          )}
          {this.state.statusError && (
            <div style={{ color: "red" }}>{this.state.statusError}</div>
          )}
        </TableCell>
        <TableCell align="center">
          <TextField
            name="remarks"
            type="text"
            required
            fullWidth
            multiline
            rows={4}
            rowsMax={4}
            variant="outlined"
            margin="normal"
            error={this.state.remarksError ? true : false}
            helperText={this.state.remarksError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            value={data.remarks}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <Tooltip
            arrow
            title="Update"
            className={classes.tooltip}
            onClick={this.handleSubmit}
          >
            <CheckCircleIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Cancel"
            className={classes.tooltip}
            onClick={handleCancelEdit}
          >
            <CancelIcon />
          </Tooltip>
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(AddStaffAttendance));
